import React from 'react';
import styled from 'styled-components';

const ImageContainer = styled.div`
  background: rgb(255, 255, 255);
  background: linear-gradient(
    180deg,
    rgba(255, 255, 255, 1) 0%,
    rgba(255, 255, 255, 1) 50%,
    ${({ theme }) => theme.colors.textQuote(0.03)} 50%,
    ${({ theme }) => theme.colors.textQuote(0.03)} 100%
  );
  display: flex;
  justify-content: center;

  @media screen and (max-width: 768px) {
    display: none;
  }
`;

const RoundedImage = styled.img`
  border-radius: 50%;
  height: 80px;
  width: 80px;
`;

type RoundedImageSeparatorProps = {
  className?: string;
  alt: string;
  src: string;
};

export function RoundedImageSeparator(props: RoundedImageSeparatorProps) {
  return (
    <ImageContainer className={props.className}>
      <RoundedImage alt={props.alt} src={props.src} />
    </ImageContainer>
  );
}
